import { Component, ElementRef, Input, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { DataFieldPreSetOptionModel } from '../../data-field-pre-set-option.model';
import { ContentLanguageLabelModel } from '@fi-shared/models';
import { fiTryContentLanguageValue } from '@fi-shared/utils/try-content-language-value';
import { AppTextService } from '@fi-shared/app-text';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { removeItem } from '@fi-shared/utils/remove-item';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
    selector: 'fi-data-field-group-edit-item-pre-set-options',
    templateUrl: './pre-set-options.component.html',
    styleUrls: ['./pre-set-options.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class DataFieldGroupEditItemPreSetOptionsComponent implements OnInit {
    @Input() options: Array<DataFieldPreSetOptionModel>;
    @Input() languageId: number;

    @ViewChildren('optionName') optionNameElements: QueryList<ElementRef>;

    constructor(
        private appTextService: AppTextService,
        private customerDataService: FiCustomerDataService,
        private contentLanguagesService: ContentLanguagesService,
    ) {}

    ngOnInit() {
        if (this.options.length === 0) {
            this.addOption();
        } else {
            this.checkNames();
        }
    }

    addOption() {
        const option = new DataFieldPreSetOptionModel();
        this.contentLanguagesService.InitializeContentLanguages(option);
        this.options.push(option);
    }

    addOptionClick() {
        this.addOption();
        setTimeout(() => this.optionNameElements.last.nativeElement.focus(), 100);
    }

    checkNames() {
        this.options.forEach((option) => checkOptionNames(option, this.languageId));
    }

    removeOption(option) {
        if (this.options.length > 1) removeItem(this.options, option);
    }

    isShowRemoveOption() {
        return this.options.length > 1;
    }

    getOptionPlaceholder(option: DataFieldPreSetOptionModel) {
        return (
            fiTryContentLanguageValue(option.Names, this.languageId) ||
            fiTryContentLanguageValue(
                option.Names,
                this.customerDataService.customerData.DefaultApplicationLanguageType,
            ) ||
            this.appTextService.get('data_field.pre_set_options_option_placeholder')
        );
    }

    onOptionDrop($event: CdkDragDrop<DataFieldPreSetOptionModel>) {
        moveItemInArray(this.options, $event.previousIndex, $event.currentIndex);
    }
}

function checkOptionNames(option: DataFieldPreSetOptionModel, languageId: number) {
    //note: what is the point of this loop ?
    for (let i = 0; i < option.Names.length; i++) {
        if (option.Names[i].ContentLanguageId === languageId) return;
    }

    addOptionName(option, languageId);
}

function addOptionName(option: DataFieldPreSetOptionModel, langId: number) {
    const optionContentLangIndex = option.Names.findIndex((name) => name.ContentLanguageId === this.languageId);
    if (optionContentLangIndex !== -1)
        option.Names.push(new ContentLanguageLabelModel(langId, '', option.Names[optionContentLangIndex].SortIndex));
}
